module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/1@2x_531586178b7dc44553d0a8750d392a46.png";